import HeroSection from '../components/HeroSection';
import CategoryCarousel from '../components/CategoryCarousel';
import UpcomingEvents from '../components/UpcomingEvents';
import NewsletterSection from '../components/NewsletterSection';
import useSEO from '../hooks/useSEO';

export default function HomePage() {
  useSEO('Inicio', 'Descubre los mejores cupones de descuento en Colombia: gastronomia, belleza, viajes, salud, cursos y mas con Cuponeo.');
  return (
    <div>
      <HeroSection />
      <div style={{ maxWidth: '1440px', margin: '0 auto' }}>
        <CategoryCarousel />
        <UpcomingEvents />
        <NewsletterSection />
      </div>
    </div>
  );
}
